<template>
    <div class="container gap-32 containerCustom" v-if="currentStep === steps.MESSAGE_SCREEN">
        <HeaderTitle
            v-if="currentStep === steps.MESSAGE_SCREEN"
            :titleName="'Cadastro'"
        />
        <MessageScreen
            v-if="currentStep === steps.MESSAGE_SCREEN"
            :srcImageMessage="DocumentUploadIcon"
            :titleMessage="'Vamos precisar que você nos envie algumas fotos de seu veículo!'"
        />
    </div>
    <CardUploadFiles
         v-if="currentStep === steps.DOCUMENT_UPLOAD"
        :titleCard="'Precisamos verificar a parte da frente do seu carro'"
        :cardDescription="'vehicle_front'"
        :textCard="'Frente do veículo'"
        :srcExampleImage="ImageFrontVehicle"
        :nextRoute="'VehicleBack'"
        :previewScreen="'PreviewVehicleFiles'"
    />
    <FooterButton v-if="currentStep === steps.MESSAGE_SCREEN" :confirmData="confirmCurrentStep"/>
</template>
<script>
    import MessageScreen from '../../components/MessageScreen.vue'
    import FooterButton from '../../components/FooterButton.vue'
    import HeaderTitle from '../../components/HeaderTitle.vue'
    import CardUploadFiles from '../../components/CardUploadFiles.vue'
    import { ref, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import DocumentUploadIcon from '../../../../public/images/Bonequinho-message.svg'
    import ImageFrontVehicle from '../../../../public/images/front_vehicle_image.svg'

    export default {
        components: {
            MessageScreen,
            FooterButton,
            HeaderTitle,
            CardUploadFiles
        },
        setup() {
            const route = useRoute();
            const currentStep = ref(1)
            const steps = {
                MESSAGE_SCREEN: 1,
                DOCUMENT_UPLOAD: 2, 
            }

            onMounted(() => {
                if (route.query.currentStep) {
                    currentStep.value = parseInt(route.query.currentStep, 10);
                }
            });
             
            function confirmCurrentStep(){
                if(currentStep.value < Object.keys(steps).length){
                    currentStep.value++
                }
            }

            return {          
                confirmCurrentStep,
                steps,
                currentStep,
                DocumentUploadIcon,
                ImageFrontVehicle,
            };
        }, 
    }
</script>